import * as React from 'react';
import slider from '../assets/Icons/ffreccia_dx_sx.svg';
import { colors } from '../colors';
import { mediaQueries } from '../mediaQueries';

interface IProps {
    pageH: number
}
export const Slider = ({ pageH }: IProps) => {

    return <div className="slider-line-container">
        <img className="slider-button" style={{ top: pageH / 2 }} src={slider} />
    </div>;

}